// ANX-117 — клиентская проверка истечения access-JWT. Нужна, чтобы проактивно
// обновлять токен ДО отправки запроса: протухший access в проде давал «failed
// to fetch» (сетевую ошибку) вместо чистого 401, из-за чего оператора не
// уводило на логин, а под композером висела непонятная ошибка.

function base64UrlDecode(s: string): string {
  const pad = s.length % 4 === 0 ? '' : '='.repeat(4 - (s.length % 4));
  return atob(s.replace(/-/g, '+').replace(/_/g, '/') + pad);
}

/** exp (мс эпохи) из JWT, либо null если токен не парсится / без exp. */
export function jwtExpMs(token: string): number | null {
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    const payload = JSON.parse(base64UrlDecode(parts[1])) as { exp?: number };
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

/**
 * Access-токен истёк (или истечёт в пределах skew)? Неразбираемый токен или
 * токен без exp считаем НЕ истёкшим — пусть сервер решит 401-ом (не ломаем
 * нестандартные/будущие форматы). Skew покрывает рассинхрон часов клиента.
 */
export function isAccessExpired(token: string, nowMs: number, skewMs = 5000): boolean {
  const exp = jwtExpMs(token);
  return exp !== null && nowMs >= exp - skewMs;
}
